import type { TRuleWithTheme } from '@/styles/theme';

// A raw hex in the Figma frame (menu/folder_list_item), not a design-system variable — so no theme token yet.
const VAULT_ROW_COLOR = '#454F73';

export const item: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(8),
    height: '32px',
    padding: `0 ${theme.spacing(8)}`,
    borderRadius: theme.spacing(4),
    ...theme.typography.ParagraphSmallMedium,
    color: VAULT_ROW_COLOR,
    textDecoration: 'none',
    transition: 'background-color 0.15s ease',

    ':hover': {
        backgroundColor: theme.colors.listItemHoverBg,
        color: VAULT_ROW_COLOR,
    },
    '&.active': {
        backgroundColor: theme.colors.listItemSelectedBg,
        color: theme.colors.accentPrimary,
    },
    '&.active:hover': {
        backgroundColor: theme.colors.listItemSelectedBg,
        color: theme.colors.accentPrimary,
    },
});

export const icon: TRuleWithTheme = () => ({
    flexShrink: 0,
});

// Wraps icon and name so the 12px gutter between them stays independent of the 8px
// that separates the name from the count.
export const label: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(12),
    flex: 1,
    minWidth: 0,
});

export const name: TRuleWithTheme = () => ({
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const count: TRuleWithTheme = () => ({
    flexShrink: 0,
    minWidth: '16px',
    textAlign: 'center',
});
